import React from 'react'
import { components } from 'cng-web-lib'

import CiaConfigEditFormProperties from './CiaPartyConfig_CiaConfigEditFormProperties'
import CIAPartyConfigApiUrls from 'src/apiUrls/CIAPartyConfigApiUrls'

const { form: {CngEditForm}} = components

function CiaConfigEditForm({history, showNotification, id, onFetchPreSuccess = () => {console.log("CiaConfigEditForm")}}){
    return(
        //* Start JSX
        <CngEditForm
			fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
			history={history}
			showNotification={showNotification}
			bodySection={
				<CiaConfigEditFormProperties.Fields
					showNotification={showNotification}
					id={id}
				/>
			}
			formikProps={CiaConfigEditFormProperties.formikProps}
			toClientDataFormat={CiaConfigEditFormProperties.toClientDataFormat}
			toServerDataFormat={CiaConfigEditFormProperties.toServerDataFormat}
			fetch={{ url: CIAPartyConfigApiUrls.GET,
			onPreSuccess: onFetchPreSuccess }}
			update={{ url: CIAPartyConfigApiUrls.PUT }}
			id={id}
		/>
    )
    //* End of Function
}

export default CiaConfigEditForm